import { createFormSectionValidator } from 'app/validators/base'

const formSectionFields = {
  date: values => {
    const date = values?.get('date')
    if (date === null) {
      return {
        isValid: false,
        message: 'Date is not available',
      }
    }
  },
}
export default createFormSectionValidator(formSectionFields, 'schedule')
